/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailShipping_domesticDeliveryOptions = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailShipping_domesticDeliveryOptions",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "shippingHelpers_shipmentQuoteConnection",
      "args": null
    }
  ],
  "type": "ShipmentQuoteConnection"
};

module.exports = fragment;
